<template>	
	<van-grid :column-num="3" icon-size="100px">	 
	  <van-grid-item :icon ="lxdyandirod" text = "联想打印安卓" >
		</van-grid-item>
		<van-grid-item :icon = "lxdyios" text = "联想打印IOS" >
		 </van-grid-item>
		 <van-grid-item :icon = "wxmini" text = "微信小程序" >
		</van-grid-item>
	  </van-grid>  	
</template>

<script>
	import { Dialog } from 'vant';
	export default {
	  name: 'appdownload',
	  components: {},
	 data(){
		 return {
			lxdyandirod:'https://www.lenovoimage.com/images/lenovoprint_and.png',
			lxdyios:'https://www.lenovoimage.com/images/lenovoprint_ios.png',
            wxmini: require('../assets/wxmini.jpg')
		 } 
		}
	}
		 
</script>

<style>
	.img{
		width:70%
		}
	.appNav{
		margin:10px;
		background: #f0f0f0;
	}
</style>
